import VehicleBlockPrimary from "./VehicleBlockPrimary";

export default VehicleBlockPrimary;
export { VehicleBlockPrimary };
